import { render, staticRenderFns } from "./LogDetails.vue?vue&type=template&id=b4939722"
import script from "./LogDetails.vue?vue&type=script&lang=js"
export * from "./LogDetails.vue?vue&type=script&lang=js"
import style0 from "./LogDetails.vue?vue&type=style&index=0&id=b4939722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports